.ux-tile-body__overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.9);
    opacity: 0;
    transform: translateY(100%);
    transition:
        transform 0.5s ease,
        opacity 0.5s ease;

    &.is-visible {
        transform: translateY(0);
        opacity: 1;
    }

    &-close {
        position: absolute;
        line-height: 0;
        top: 15px;
        right: 15px;
        cursor: pointer;

        @media screen and (max-width: 567px) {
            top: 10px;
            right: 10px;
        }
    }

    &-content {
        margin: auto;
        display: flex;
        flex-direction: column;
        text-align: center;
        max-width: 250px;
        justify-content: center;
        height: 100%;

        > div {
            margin-bottom: 10px;
        }

        ux-button {
            background: white;
            margin-bottom: 10px;
        }
    }

    ux-button ux-icon {
        font-size: 24px;
        margin: -5px 0 -5px 10px;
    }
}

.ux-w-my-machines-item__button {
    --ux-button-bg-color: #fff;

    ux-icon {
        height: 20px;
    }
}

.service-case-error-tooltip {
    display: grid;
    grid-template-rows: [icon] auto [header] auto [content] auto;
    justify-items: center;
    align-items: center;

    ux-icon {
        grid-area: icon;
    }

    .headerText {
        grid-area: header;
    }

    .bodyText {
        grid-area: content;
    }
}

.ux-tile-body__button-group {
    ux-button:disabled {
        pointer-events: auto;
    }
}

.ux-tile-body {
    uxc-auth-image {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
    }

    ux-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}
